import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys } from './helper'
import { httpGet } from '../core/restClient'
// import { appLoading, appLoaded, toastError, toastSuccess } from './app'
// import r from 'reactotron-react-js'

const GET_GOA_BY_COMPANY = makeKeys('GET_GOA_BY_COMPANY')
const GET_GOA_ITEMS = makeKeys('GET_GOA_ITEMS')
const GET_PROJECT_BY_COMPANY = makeKeys('GET_PROJECT_BY_COMPANY')
const ADD_OTHER_PROJECT = 'ADD_OTHER_PROJECT'
const CLEAR_OTHER_PROJECT = 'CLEAR_OTHER_PROJECT'
const GET_SPECIAL_APPROVAL= makeKeys('GET_SPECIAL_APPROVAL')

const FETCH_GOAS_PROJECT = makeKeys('FETCH_GOAS_PROJECT')
const FETCH_GOAS = makeKeys('FETCH_GOAS')

export const getGoaByCompany = makeAction(GET_GOA_BY_COMPANY.REQUEST, 'company')
export const getGoaItem = makeAction(GET_GOA_ITEMS.REQUEST, 'goaId', 'processCode')
export const getProjectByCompany = makeAction(GET_PROJECT_BY_COMPANY.REQUEST, 'company')
export const addOtherProject = makeAction(ADD_OTHER_PROJECT, 'name')
export const clearOtherProject = makeAction(CLEAR_OTHER_PROJECT)
export const getSpecialApproval = makeAction(GET_SPECIAL_APPROVAL.REQUEST, 'projectId')
export const fetchGoasProject = makeAction(FETCH_GOAS_PROJECT.REQUEST)
export const fetchGoas = makeAction(FETCH_GOAS.REQUEST)

const getGoaByCompanySuccess = makeAction(GET_GOA_BY_COMPANY.SUCCESS, 'company', 'data')
const getGoaItemSuccess = makeAction(GET_GOA_ITEMS.SUCCESS, 'goaId', 'data')
const getProjectByCompanySuccess = makeAction(GET_PROJECT_BY_COMPANY.SUCCESS, 'company', 'data')
const getSpecialApprovalSuccess = makeAction(GET_SPECIAL_APPROVAL.SUCCESS, 'projectId', 'data')
const fetchGoasProjectSuccess = makeAction(FETCH_GOAS_PROJECT.SUCCESS,'data')
const fetchGoasSuccess = makeAction(FETCH_GOAS.SUCCESS,'data')

const initial = {
  goa: {},
  goas:{  data:[], loading:false},
  goaCompanyLoading: undefined,
  goaLoading: false,
  goaItems: {},
  goaItemByGoaIdLoading: undefined,
  goaItemLoading: false,
  projects: {
    other: []
  },
  projectCompanyLoading: undefined,
  projectLoading: false,
  specialApprovals: {},
  specialApprovalProjectIdLoading: undefined,
  specialApprovalLoading: false,
  goasProject: [],
}

function* getGoaByCompanyRequest(action) {
  const { company } = action.payload
  try {
    const response = yield httpGet('goas/default', { companyCode: company })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getGoaByCompanySuccess(company, response.data))
      }
    }
  } catch (e) {
  }
}

function* getGoaItemRequest(action) {
  const { goaId, processCode } = action.payload
  try {
    const response = yield httpGet(`goas/${goaId}/items`, { processCode })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getGoaItemSuccess(goaId, response.data))
      }
    }
  } catch (e) {
  }
}

function* getProjectByCompanyRequest(action) {
  const { company } = action.payload
  try {
    const response = yield httpGet('goas/default/projects', { companyCode: company })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getProjectByCompanySuccess(company, response.data))
      }else{
        yield put(getProjectByCompanySuccess('other', []))
      }
    }
  } catch (e) {
  }
}

function* getSpecialApprovalRequest(action) {
  const { projectId } = action.payload
  try {
    const response = yield httpGet('goas/specialApprovals', { projectId })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getSpecialApprovalSuccess(projectId, response.data))
      }
    }
  } catch (e) {
  }
}

function* fetchGoasProjectRequest() {
  try {
    const response = yield httpGet('goas/projects')
    if (response.status === 200) {
      if (response.data) {
        yield put(fetchGoasProjectSuccess(response.data))
      }
    }
  } catch (e) {
  }
}

function* fetchGoasProjecRequest() {
  try {
    const response = yield httpGet('goas')
    if (response.status === 200) {
      if (response.data) {
        yield put(fetchGoasSuccess(response.data))
      }
    }
  } catch (e) {
  }
}

export function* watchGoaSaga() {
  yield takeLatest(GET_GOA_BY_COMPANY.REQUEST, getGoaByCompanyRequest)
  yield takeLatest(GET_GOA_ITEMS.REQUEST, getGoaItemRequest)
  yield takeLatest(GET_PROJECT_BY_COMPANY.REQUEST, getProjectByCompanyRequest)
  yield takeLatest(GET_SPECIAL_APPROVAL.REQUEST, getSpecialApprovalRequest)

  yield takeLatest(FETCH_GOAS_PROJECT.REQUEST, fetchGoasProjectRequest)
  yield takeLatest(FETCH_GOAS.REQUEST, fetchGoasProjecRequest)
}

export default createReducer(initial, state => ({
  [GET_GOA_BY_COMPANY.REQUEST]: (data) => ({
    ...state,
    goaCompanyLoading: data.company,
    goaLoading: true
  }),
  [GET_GOA_BY_COMPANY.SUCCESS]: (data) => ({
    ...state,
    goa: {
      ...state.goa,
      [data.company]: data.data
    },
    goaCompanyLoading: undefined,
    goaLoading: false
  }),
  [GET_GOA_ITEMS.REQUEST]: (data) => ({
    ...state,
    goaItemByGoaIdLoading: data.goaId,
    goaItemLoading: true
  }),
  [GET_GOA_ITEMS.SUCCESS]: (data) => ({
    ...state,
    goaItems: {
      ...state.goaItems,
      [data.goaId]: data.data
    },
    goaItemByGoaIdLoading: undefined,
    goaItemLoading: false
  }),
  [GET_PROJECT_BY_COMPANY.REQUEST]: (data) => ({
    ...state,
    projectCompanyLoading: data.company,
    projectLoading: true
  }),
  [GET_PROJECT_BY_COMPANY.SUCCESS]: (data) => ({
    ...state,
    projects: {
      ...state.projects,
      [data.company]: data.data
    },
    projectCompanyLoading: undefined,
    projectLoading: false
  }),
  [GET_SPECIAL_APPROVAL.REQUEST]: (data) => ({
    ...state,
    specialApprovalProjectIdLoading: data.projectId,
    specialApprovalLoading: true
  }),
  [GET_SPECIAL_APPROVAL.SUCCESS]: (data) => ({
    ...state,
    specialApprovals: {
      ...state.specialApprovals,
      [data.projectId]: data.data
    },
    specialApprovalProjectIdLoading: undefined,
    specialApprovalLoading: false
  }),
  [ADD_OTHER_PROJECT]: (data) => ({
    ...state,
    projects: {
      ...state.projects,
      other: [ ...state.projects.other, { id: data.name, projectName: data.name }]
    }
  }),
  [CLEAR_OTHER_PROJECT]: (data) => ({
    ...state,
    projects: {
      ...state.projects,
      other: []
    }
  }),
  [FETCH_GOAS_PROJECT.REQUEST]: () => ({
    ...state,
    specialApprovalLoading: true
  }),
  [FETCH_GOAS_PROJECT.SUCCESS]: (data) => ({
    ...state,
    goasProject: data.data,
    specialApprovalLoading: false
  }),
  [FETCH_GOAS.REQUEST]: () => ({
    ...state,
    goas: { data: [], loading: true }
  }),
  [FETCH_GOAS.SUCCESS]: (data) => ({
    ...state,
    goas: { data: data.data, loading: false }
  }),
}))